import { Badge, Col, Row } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import image from "../../assets/images/five.jpg";
import { formatLastModified } from "../../utils/TimeConvert";
import LoadingCom from "../LoadingCom";

const UserProjectsData = ({ projectsData, title, Imageloading }) => {
  console.log(projectsData, "projectDataDetailsssss");
  const navigate = useNavigate();
  return (
    <Row gutter={[10, 10]}>
      {projectsData?.length > 0 ? (
        projectsData?.map((project, id) => (
          <Col
            // lg={8}
            md={12}
            key={id}
            className="cursor-pointer"
            onClick={() =>
              navigate(`/projects-details/${project?.SK}`, {
                state: { data: project },
              })
            }
          >
            <Badge.Ribbon text={project?.ProjectStatus} color={"green"} />
            <div className="bg-pureWhite rounded-xl shadow-signupBoxShadow p-3 h-full">
              {Imageloading ? (
                <LoadingCom />
              ) : (
                <img
                  className="rounded-lg h-[200px] w-full shadow-profileShadow"
                  // src={project?.ImageUrl}
                  src={
                    "https://cdn.prod.website-files.com/63c5e29f1b5bc83fe0af2489/6424d753f8eb7a9e69c372fc_Gantt%20Chart%20Online%20Software%20Instagantt%20Ideation%202.webp"
                  }
                  alt={id}
                  // width={400}
                  // height={140}
                />
              )}
              <div className="flex justify-between items-center mt-2">
                <p className="text-base text-DarkGrey font-semibold w-[80%]">
                  {project?.Title}
                </p>
              </div>
              <div className="flex mt-2 justify-between items-center">
                <p className="text-sm text-DarkGrey ">
                  Location:
                  <span className="font-bold"> {project?.Location} </span>
                </p>
              </div>
              <div className="flex justify-between">
                <p className="flex text-[10px] justify-between mt-2 text-gray-400">
                  Category:
                  {"  " + project?.Category}
                  {/* {formatLastModified(project?.lastChange)} */}
                </p>
                <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                  <span className="font-bold">
                    Priority:
                    {/* <ClockIcon /> */}
                  </span>
                  {/* <span>{course?.duration}</span> */}
                  <span> {project?.Priority}</span>
                </p>
              </div>

              <div className="flex justify-between items-center mt-2">
                <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                  <span>{/* <LocationIcon /> */}</span>
                  {/* <span>{course?.location}</span> */}
                  {/* <span>City, Country</span> */}
                </p>
                <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                  {/* {course?.contentType} */}
                  {/* <GradientButton className={"w-48"}>
                      View Campaign
                      </GradientButton> */}
                </p>
              </div>
            </div>
          </Col>
        ))
      ) : (
        <div className="w-full">
          <LoadingCom />
        </div>
      )}
    </Row>
  );
};

export default UserProjectsData;
